// ─── BuyBoxChip ─────────────────────────────────────────────────────────────
// Renders the current buy-box verdict for a deal or property. Three states:
//
//   in_box     → green pill "In-Box"
//   filtered   → gray pill "Filtered"       (reason shown as tooltip)
//   undecided  → nothing rendered (returns null) so the card/facts stay clean
//                until the rule is set up
//
// Manually-overridden verdicts are visually distinct — the pill gets a small
// hollow ring to signal "human said so, not the rule". Hover for the reason.
//
// Props:
//   verdict — 'in_box' | 'filtered' | 'undecided'
//   source  — 'auto' | 'manual'
//   reason  — string | null (only meaningful when verdict === 'filtered')
//   size    — 'sm' (default, for cards) | 'md' (for the FactRow)

export default function BuyBoxChip({ verdict, source = "auto", reason = null, size = "sm" }) {
  if (!verdict || verdict === "undecided") return null;

  const isManual = source === "manual";
  const isIn = verdict === "in_box";
  const label = isIn ? "In-Box" : "Filtered";
  const title = [
    isManual ? "Manual override" : "Auto-graded",
    reason ? `— ${reason}` : "",
  ].filter(Boolean).join(" ");

  const base = isIn
    ? "text-[#7cbb99] bg-[rgba(79,157,118,0.15)] border-[rgba(79,157,118,0.4)]"
    : "text-[#8a8a8a] bg-[rgba(138,138,138,0.1)] border-[rgba(106,106,106,0.4)]";

  const ring = isManual ? "ring-1 ring-inset ring-current" : "";

  const sizing = size === "md"
    ? "text-[11px] px-2 py-0.5"
    : "text-[10px] px-1.5 py-0.5";

  return (
    <span
      title={title}
      className={`inline-flex items-center rounded-full border font-semibold ${base} ${ring} ${sizing}`}
    >
      {label}
      {isManual && <span className="ml-1 opacity-70">·M</span>}
    </span>
  );
}
